const API_BASE = (process.env.REACT_APP_API_URL || "http://localhost:3002").replace(/\/$/, "");

export function fixImageUrl(url) {
  if (!url) return null;
  // Replace any localhost URL (any port) with the configured API base
  return url.replace(/https?:\/\/localhost:\d+/g, API_BASE);
}
